<template>
  <div>
    <div class="bg-main pb-80 md:pb-112">
      <div class="bg-picker">
        <div class="container xxl:px-24 py-48 sm:py-56">
          <h2 class="mb-0 text-center">{{ page.title }}</h2>
        </div>
      </div>
      <div class="container xxl:px-24 pt-56">
        <div
          v-if="page.articles"
          class="articles flex flex-wrap overflow-hidden md:-mx-12"
          itemscope
          itemtype="https://schema.org/ItemList"
        >
          <div
            v-for="(article, index) in page.articles"
            :key="article.id"
            class="w-full mb-24 sm:mb-32 md:px-12 md:w-1/3 md:mb-56"
          >
            <nuxt-link
              v-if="index < paginationLimit"
              :to="article.permalink"
              class=""
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/Article"
            >
              <div class="block h-224 md:h-280 overflow-hidden rounded-lg">
                <nuxt-img
                  :src="article.image"
                  preset="standard"
                  sizes="mob375:100vw mob390:100vw mob414:100vw desk:420px"
                  alt="Relaterade artiklar-bild"
                  class="object-center object-cover w-full h-full"
                  itemprop="image"
                />
              </div>
              <div>
                <h4 class="my-12" itemprop="name">
                  {{ article.title }}
                </h4>
                <p
                  v-if="article.excerpt"
                  class="text-muted text-base-regular mb-12"
                >
                  {{ article.excerpt }}
                </p>
                <div class="btn btn--md btn--secondary">
                  {{ $lang('article_listing_page', 'read_more') }}
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
        <div class="text-center">
          <div class="text-black-75 text-sm">
            {{ visibleArticlesText }}
          </div>
          <button
            v-if="paginationLimit < page.articles.length"
            class="btn btn--primary btn--lg mx-auto w-fit-content mt-16"
            @click.prevent="paginationLimit += 3"
          >
            {{ $lang('article_listing_page', 'load_more_articles') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paginationLimit: 6 as number,
    };
  },
  computed: {
    visibleArticlesText(): string {
      let limit = this.paginationLimit;
      if (limit > this.page.articles.length) {
        limit = this.page.articles.length;
      }
      const text = this.$lang('article_listing_page', 'visible_articles')
        .replace('{{visibleArticles}}', limit.toString())
        .replace('{{totalArticles}}', this.page.articles.length);

      return text;
    },
  },
});
</script>
